module.exports = __webpack_public_path__ + "img/kiss-blue.acdb13dc.svg";